module.exports = __webpack_public_path__ + "media/packs/images/no-attentions-2460a0c89c7f736eb41cb33e3b0989a9.svg";